import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { getLocalizedText } from '../utils/localization'
import { ComponentRenderer } from './ComponentRenderer'
import { cn } from '../lib/utils'

interface CTAProps {
  component: Component
  locale: LocaleCode
  storeId: string
  apiUrl: string
  style: React.CSSProperties
}

export function CTA({ component, locale, storeId, apiUrl, style }: CTAProps) {
  const config = component.config as any

  const title = getLocalizedText(config.title, locale)
  const subtitle = getLocalizedText(config.subtitle, locale)
  const layoutType = config.layout || 'centered'
  const backgroundImage = config.backgroundImage

  const containerStyle: React.CSSProperties = {
    ...style,
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
    backgroundSize: backgroundImage ? 'cover' : undefined,
    backgroundPosition: backgroundImage ? 'center' : undefined,
  }

  const textColor = backgroundImage ? '#ffffff' : style.color

  return (
    <div style={containerStyle} className="w-full relative">
      {backgroundImage && (
        <div className="absolute inset-0 bg-black opacity-50" />
      )}

      <div className={cn(
        'max-w-7xl mx-auto relative z-10',
        layoutType === 'centered' ? 'text-center' : 'flex items-center justify-between'
      )}>
        <div className={layoutType === 'split' ? 'flex-1' : ''}>
          {title && (
            <h2 className="text-4xl font-bold mb-4" style={{ color: textColor }}>
              {title}
            </h2>
          )}
          {subtitle && (
            <p
              className="text-xl mb-8"
              style={{
                color: textColor,
                opacity: backgroundImage ? 0.9 : 0.8
              }}
            >
              {subtitle}
            </p>
          )}
        </div>

        {component.children && component.children.length > 0 && (
          <div className={cn(
            'flex gap-4',
            layoutType === 'centered' ? 'justify-center' : ''
          )}>
            {component.children.map((child) => (
              <ComponentRenderer
                key={child.id}
                component={child}
                locale={locale}
                storeId={storeId}
                apiUrl={apiUrl}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
